import { createAction, props } from "@ngrx/store"
import { StaffDto } from "./staffs.dtos"

export const fetchStaffs = createAction(
    '[Staff Module] fetch staffs',
    props<{merchantId: string, skip?: any, limit?: any, filter?: any, search?:string}>()
)

export const fetchStaffsFailed = createAction(
    '[Staff Module] STATUS: fetch staffs failed'
)

export const fetchStaffsSuccess = createAction(
    '[Staff Module] STATUS: fetch staffs success',
    props<{staffs: any}>()
)

export const fetchStaff = createAction(
    '[Staff Module] fetch staff',
    props<{merchantId: string, staffId: string}>()
)

export const fetchStaffFailed = createAction(
    '[Staff Module] STATUS: fetch staff failed'
)

export const fetchStaffSuccess = createAction(
    '[Staff Module] STATUS: fetch staff success',
    props<{staff: any}>()
)

export const createStaff = createAction(
    '[Staff Module] create staff',
    props<{staffDto: StaffDto}>()
)

export const createStaffFailed = createAction(
    '[Staff Module] STATUS: create staff failed'
)

export const createStaffSuccess = createAction(
    '[Staff Module] STATUS: create staff success',
    props<{response: any}>()
)

export const updateStaff = createAction(
    '[Staff Module] update staff',
    props<{staffDto: StaffDto, staffId: string}>()
)

export const updateStaffFailed = createAction(
    '[Staff Module] STATUS: update staff failed'
)

export const updateStaffSuccess = createAction(
    '[Staff Module] STATUS: update staff success',
    props<{response: any}>()
)
